var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorporateExternalDataDataIconTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 144,
    viewBox: "0 0 190 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 94,
    r: 50,
    fill: "#142533"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8122 63.7607L94.916 62.0929L99.0855 64.8526L97.9816 66.5204L93.8122 63.7607Z",
    fill: "#142533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.58 59.6357L88.6838 57.9679L92.8533 60.7276L91.7494 62.3954L87.58 59.6357Z",
    fill: "#142533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7428 55.7722L82.8466 54.1044L87.0161 56.8641L85.9122 58.5318L81.7428 55.7722Z",
    fill: "#142533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9056 51.9086L77.0094 50.2408L81.1789 53.0005L80.075 54.6683L75.9056 51.9086Z",
    fill: "#142533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0464 48.0305L71.1503 46.3627L75.3197 49.1224L74.2158 50.7902L70.0464 48.0305Z",
    fill: "#142533"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2092 44.1669L65.3131 42.4992L69.4825 45.2589L68.3786 46.9266L64.2092 44.1669Z",
    fill: "#142533"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.372 40.3034L59.4759 38.6356L63.6453 41.3953L62.5414 43.0631L58.372 40.3034Z",
    fill: "#142533"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5348 36.4398L53.6387 34.772L57.8081 37.5317L56.7042 39.1995L52.5348 36.4398Z",
    fill: "#142533"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6976 32.5763L47.8015 30.9085L51.9709 33.6682L50.867 35.3359L46.6976 32.5763Z",
    fill: "#142533"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8604 28.7127L41.9643 27.0449L46.1337 29.8046L45.0298 31.4724L40.8604 28.7127Z",
    fill: "#142533"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0232 24.8491L36.1271 23.1814L40.2965 25.9411L39.1926 27.6088L35.0232 24.8491Z",
    fill: "#142533"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0232 24.8491L36.1271 23.1814L40.2965 25.9411L39.1926 27.6088L35.0232 24.8491Z",
    fill: "#142533"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0232 24.8491L36.1271 23.1814L40.2965 25.9411L39.1926 27.6088L35.0232 24.8491Z",
    fill: "#142533"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0232 24.8491L36.1271 23.1814L40.2965 25.9411L39.1926 27.6088L35.0232 24.8491Z",
    fill: "#142533"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.186 20.9856L30.2899 19.3178L34.4593 22.0775L33.3554 23.7453L29.186 20.9856Z",
    fill: "#142533"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.186 20.9856L30.2899 19.3178L34.4593 22.0775L33.3554 23.7453L29.186 20.9856Z",
    fill: "#142533"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.186 20.9856L30.2899 19.3178L34.4593 22.0775L33.3554 23.7453L29.186 20.9856Z",
    fill: "#142533"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.186 20.9856L30.2899 19.3178L34.4593 22.0775L33.3554 23.7453L29.186 20.9856Z",
    fill: "#142533"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3488 17.122L24.4527 15.4543L28.6221 18.2139L27.5182 19.8817L23.3488 17.122Z",
    fill: "#142533"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3488 17.122L24.4527 15.4543L28.6221 18.2139L27.5182 19.8817L23.3488 17.122Z",
    fill: "#142533"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3488 17.122L24.4527 15.4543L28.6221 18.2139L27.5182 19.8817L23.3488 17.122Z",
    fill: "#142533"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3488 17.122L24.4527 15.4543L28.6221 18.2139L27.5182 19.8817L23.3488 17.122Z",
    fill: "#142533"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5116 13.2585L18.6155 11.5907L22.7849 14.3504L21.681 16.0181L17.5116 13.2585Z",
    fill: "#142533"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5116 13.2585L18.6155 11.5907L22.7849 14.3504L21.681 16.0181L17.5116 13.2585Z",
    fill: "#142533"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5116 13.2585L18.6155 11.5907L22.7849 14.3504L21.681 16.0181L17.5116 13.2585Z",
    fill: "#142533"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5116 13.2585L18.6155 11.5907L22.7849 14.3504L21.681 16.0181L17.5116 13.2585Z",
    fill: "#142533"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6744 9.3949L12.7783 7.72713L16.9477 10.4868L15.8438 12.1546L11.6744 9.3949Z",
    fill: "#142533"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6744 9.3949L12.7783 7.72713L16.9477 10.4868L15.8438 12.1546L11.6744 9.3949Z",
    fill: "#142533"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6744 9.3949L12.7783 7.72713L16.9477 10.4868L15.8438 12.1546L11.6744 9.3949Z",
    fill: "#142533"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6744 9.3949L12.7783 7.72713L16.9477 10.4868L15.8438 12.1546L11.6744 9.3949Z",
    fill: "#142533"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8372 5.53134L6.94108 3.86357L11.1105 6.62326L10.0066 8.29103L5.8372 5.53134Z",
    fill: "#142533"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8372 5.53134L6.94108 3.86357L11.1105 6.62326L10.0066 8.29103L5.8372 5.53134Z",
    fill: "#142533"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8372 5.53134L6.94108 3.86357L11.1105 6.62326L10.0066 8.29103L5.8372 5.53134Z",
    fill: "#142533"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8372 5.53134L6.94108 3.86357L11.1105 6.62326L10.0066 8.29103L5.8372 5.53134Z",
    fill: "#142533"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6744 9.3949L12.7783 7.72713L16.9477 10.4868L15.8438 12.1546L11.6744 9.3949Z",
    fill: "#142533"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6744 9.3949L12.7783 7.72713L16.9477 10.4868L15.8438 12.1546L11.6744 9.3949Z",
    fill: "#142533"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6744 9.3949L12.7783 7.72713L16.9477 10.4868L15.8438 12.1546L11.6744 9.3949Z",
    fill: "#142533"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6744 9.3949L12.7783 7.72713L16.9477 10.4868L15.8438 12.1546L11.6744 9.3949Z",
    fill: "#142533"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.66779L1.10387 1.39475e-05L5.2733 2.7597L4.16943 4.42747L0 1.66779Z",
    fill: "#142533"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.66779L1.10387 1.39475e-05L5.2733 2.7597L4.16943 4.42747L0 1.66779Z",
    fill: "#142533"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.66779L1.10387 1.39475e-05L5.2733 2.7597L4.16943 4.42747L0 1.66779Z",
    fill: "#142533"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.66779L1.10387 1.39475e-05L5.2733 2.7597L4.16943 4.42747L0 1.66779Z",
    fill: "#142533"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152 74.0013L150 72.0013H135C134.119 72.2157 133.669 72.4148 133 73.0012L129 77.0012C128.39 77.6536 128.139 78.0882 128 79.0013V104.001L130 106.001H150L152 104.001V74.0013ZM150 104.001H130V79.5013H134L135.5 78.0013V74.0013H150V104.001ZM130 78.0013L134 74.0013V78.0013H130Z",
    fill: "#D9D9D9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M134 79.5013C134 79.5013 134.691 79.3101 135 79.0013C135.309 78.6926 135.5 78.0013 135.5 78.0013L134 79.5013Z",
    fill: "#D9D9D9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 72.5013C150.948 71.949 150 72.0013 150 72.0013L152 74.0013C152 74.0013 152.052 73.0536 151.5 72.5013Z",
    fill: "#D9D9D9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 105.501C152.052 104.949 152 104.001 152 104.001L150 106.001C150 106.001 150.948 106.054 151.5 105.501Z",
    fill: "#D9D9D9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 105.501C129.052 106.054 130 106.001 130 106.001L128 104.001C128 104.001 127.948 104.949 128.5 105.501Z",
    fill: "#D9D9D9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M139 106.001V113.001H114V106.001H112V115.001H169V106.001H167V113.001H141V106.001H139Z",
    fill: "#D9D9D9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.001 74.0026L177.001 72.0026H162.001C161.121 72.217 160.67 72.4161 160.001 73.0025L156.001 77.0025C155.391 77.6549 155.14 78.0895 155.001 79.0026V104.003L157.001 106.003H177.001L179.001 104.003V74.0026ZM177.001 104.003H157.001V79.5026H161.001L162.501 78.0026V74.0026H177.001V104.003ZM157.001 78.0026L161.001 74.0026V78.0026H157.001Z",
    fill: "#D9D9D9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M161.001 79.5026C161.001 79.5026 161.693 79.3114 162.001 79.0026C162.31 78.6939 162.501 78.0026 162.501 78.0026L161.001 79.5026Z",
    fill: "#D9D9D9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M178.501 72.5026C177.949 71.9503 177.001 72.0026 177.001 72.0026L179.001 74.0026C179.001 74.0026 179.054 73.0549 178.501 72.5026Z",
    fill: "#D9D9D9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M178.501 105.503C179.054 104.95 179.001 104.003 179.001 104.003L177.001 106.003C177.001 106.003 177.949 106.055 178.501 105.503Z",
    fill: "#D9D9D9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M155.501 105.503C156.054 106.055 157.001 106.003 157.001 106.003L155.001 104.003C155.001 104.003 154.949 104.95 155.501 105.503Z",
    fill: "#D9D9D9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.001 74.0026L123.001 72.0026H108.001C107.121 72.217 106.67 72.4161 106.001 73.0025L102.001 77.0025C101.391 77.6549 101.14 78.0895 101.001 79.0026V104.003L103.001 106.003H123.001L125.001 104.003V74.0026ZM123.001 104.003H103.001V79.5026H107.001L108.501 78.0026V74.0026H123.001V104.003ZM103.001 78.0026L107.001 74.0026V78.0026H103.001Z",
    fill: "#D9D9D9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M107.001 79.5026C107.001 79.5026 107.693 79.3114 108.001 79.0026C108.31 78.6939 108.501 78.0026 108.501 78.0026L107.001 79.5026Z",
    fill: "#D9D9D9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M124.501 72.5026C123.949 71.9503 123.001 72.0026 123.001 72.0026L125.001 74.0026C125.001 74.0026 125.054 73.0549 124.501 72.5026Z",
    fill: "#D9D9D9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M124.501 105.503C125.054 104.95 125.001 104.003 125.001 104.003L123.001 106.003C123.001 106.003 123.949 106.055 124.501 105.503Z",
    fill: "#D9D9D9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M101.501 105.503C102.054 106.055 103.001 106.003 103.001 106.003L101.001 104.003C101.001 104.003 100.949 104.95 101.501 105.503Z",
    fill: "#D9D9D9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 102.001V89.0013H111.5V102.001H109.5Z",
    fill: "#D9D9D9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M105 102.001H107V93.0013H105V102.001Z",
    fill: "#D9D9D9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M114 102.001V85.0013H116V102.001H114Z",
    fill: "#D9D9D9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 102.001V81.0013H120.5V102.001H118.5Z",
    fill: "#D9D9D9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M137 76.0013H142V78.0013H137V76.0013Z",
    fill: "#D9D9D9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 86.0013H148.5V88.0013H131.5V86.0013Z",
    fill: "#D9D9D9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 81.0013V83.0013H141.5V81.0013H131.5Z",
    fill: "#D9D9D9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 81.0013V83.0013H148.5V81.0013H143.5Z",
    fill: "#D9D9D9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 76.0013H148.5V78.0013H143.5V76.0013Z",
    fill: "#D9D9D9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 101.001V103.001H148.5V101.001H131.5Z",
    fill: "#D9D9D9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 96.0013H139V98.0013H131.5V96.0013Z",
    fill: "#D9D9D9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M141 96.0013H148.5V98.0013H141V96.0013Z",
    fill: "#D9D9D9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 91.0013V93.0013H148.5V91.0013H138.5Z",
    fill: "#D9D9D9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 91.0013H136.5V93.0013H131.5V91.0013Z",
    fill: "#D9D9D9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M172 99.0013L167.5 92.5013L169 91.0013L175 96.0013L175.5 95.5013L169 90.5013C167.978 91.8057 167.177 91.8557 165.5 92.5013H166.5H167L171.5 99.5013L172 99.0013Z",
    fill: "#D9D9D9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M175 96.0013C174.292 97.8219 173.697 98.5676 172 99.0013L171.5 99.5013C174.498 99.0299 175.078 97.9233 175.5 95.5013L175 96.0013Z",
    fill: "#D9D9D9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170 88.0013C170 90.7627 167.761 93.0013 165 93.0013C162.239 93.0013 160 90.7627 160 88.0013C160 85.2399 162.239 83.0013 165 83.0013C167.761 83.0013 170 85.2399 170 88.0013ZM165 92.0013C167.209 92.0013 169 90.2105 169 88.0013C169 85.7922 167.209 84.0013 165 84.0013C162.791 84.0013 161 85.7922 161 88.0013C161 90.2105 162.791 92.0013 165 92.0013Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorporateExternalDataDataIconTail);
export default __webpack_public_path__ + "static/media/IncorporateExternalDataDataIconTail.8940b574cbb21da488fef3d6df547bb6.svg";
export { ForwardRef as ReactComponent };